import {override} from "mobx";
import {LanguageMenuModuleMenuModel} from "./language-menu-module.menu.model";
import styles from "../../styles/language-menu.module.scss";
import type {LanguageViewModel} from "../../../../domain/locale/models/language/language.view-model";

export class LanguageMenuModuleMenuClassicModel extends LanguageMenuModuleMenuModel {
  @override get logoSize(): Number {
    return 20;
  }

  @override get className(): String {
    return styles.classic
  }

  @override get headerName(): String {
    return this.selectedLanguage.name;
  }

  @override get shouldRenderButtonLabel(): Boolean {
    return false;
  }

  @override get shouldArrowOpenMenu(): Boolean {
    return true;
  }

  @override get showSelectedLanguageLabel(): Boolean {
    return false;
  }

  @override get shouldRenderHeaderFullDisplay(): Boolean {
    return false;
  }

  @override get shouldCollapsedOnBgClick(): Boolean {
    return true;
  }

  @override get headerItems(): Array<LanguageViewModel> {
    return [this.selectedLanguage];
  }

  @override get collapsedItems(): Array<LanguageViewModel> {
    return this.languages;
  }

  @override get items(): Array<LanguageViewModel> {
    return null;
  }

  @override get numOfHeaderItemsDisplay(): Number {
    return 1
  }
}